import { render, staticRenderFns } from "./EntregasSemComprometimentoDash.vue?vue&type=template&id=7cde3961"
import script from "./EntregasSemComprometimentoDash.vue?vue&type=script&lang=js"
export * from "./EntregasSemComprometimentoDash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports